let BACKEND_URL = process.env.NODE_ENV==="production"?"https://smartforms.app/":"http://localhost:8082"

var application_constants = {
    BACKEND_URL:BACKEND_URL
}

export default application_constants